import { render, staticRenderFns } from "./CustomSidebar.vue?vue&type=template&id=4a94689b&scoped=true&"
import script from "./CustomSidebar.vue?vue&type=script&lang=js&"
export * from "./CustomSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CustomSidebar.vue?vue&type=style&index=0&id=4a94689b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94689b",
  null
  
)

export default component.exports